jQuery(document).ready(function(){

     function performSearch(val) 
     {
      const query = val.trim();

      if(query !== "") 
      {
          window.location.href = "/search?q=" + encodeURIComponent(query);
      }
     }

      function notify(message, type)
      {
        let wrap = "";

        if(type === "success")
        {
          wrap = $('.toast.toast--green');
        }
        else if(type === "info")
        {
          wrap = $('.toast.toast--blue');
        }
        else if(type === "error")
        {
          wrap = $('.toast.toast--red');
        }

        if(wrap === "")
        {
          return;
        }

        wrap.find(".toast__message").html(message);
        wrap.addClass("active");
        setTimeout(function(){
          $(".toast.toast--red").removeClass("active");
          $(".toast.toast--green").removeClass("active");
          $(".toast__message").html("");
        },3000);
      }

      function refreshCart(row_id,message)
      {
        const wrapper = $(".cart_items_container");

        if(wrapper.length === 0)
        {
          return;
        }

        const url = wrapper.attr('data-url');
        $.ajax({
          type: 'GET',
          url: url,
          success: function(data) {
            wrapper.html(data);

            if(typeof message !== "undefined" && typeof row_id !== "undefined")
            {
              notify(message,"error");
            }
          },
          error: function(err) {
            notify(err.responseJSON.message,"error"); 
          }
        });
      }

     function updateCartCaret()
      {
        $.ajax({
          type: 'POST',
          url: '/cart',
          dataType: 'json',
          success: function(data) {
            if(data.item_count > 0)
            {
              if($(".cart_items_count").length > 0)
              {
                $(".cart_items_count").text(data.item_count);
              }
              else
              {
                const cart_items_count_elem = "<span class='cart_items_count'>"+data.item_count+"</span>";
                $('.header__btn-cart').append(cart_items_count_elem);
              }
            }
            else
            {
              $('.header__btn-cart').find(".cart_items_count").remove();
            }
          },
          error: function(err) {
          }
        });
      }

      function updateCartItemQty(id,qty)
      {
        const wrapper = $('.cart_items_box_two_col[data-id="'+id+'"]');
        wrapper.addClass("loading");

        $.ajax({
          type: 'POST',
          url: '/cart/change.js',
          dataType: 'json',
          data: {
            id: id,
            quantity: qty
          },
          success: function() {
            wrapper.removeClass("loading");
            updateCartCaret();
            refreshCart();
          },
          error: function(err) {
            wrapper.removeClass("loading");
            refreshCart(id,err.responseJSON.message);
          }
        });
      }

    $(document).on('click','.header-menu .fa-solid, .mobile_menu .fa-solid',function(){

        const wrap = $(this).closest('li');
        const sub_menu_wrap = wrap.find(".sub-menu-wrapper");

        if($(this).hasClass('fa-chevron-up'))
        {
            sub_menu_wrap.slideUp();
            $(this).removeClass("fa-chevron-up").addClass('fa-chevron-down');
        }
        else
        {
            sub_menu_wrap.slideDown();
            $(this).removeClass("fa-chevron-down").addClass('fa-chevron-up');
        }

    });

    $(document).on('click','#menu_action',function(){

        const btn = $(this).find('.fa-solid');
        const wrap = $(".header-menu");
        const main_content = $("#MainContent");

        if(btn.hasClass('fa-bars'))
        {
            wrap.addClass('active');
            btn.removeClass("fa-bars").addClass('fa-xmark');
            main_content.addClass('loading');
        }
        else
        {
            wrap.removeClass('active');
            btn.removeClass("fa-xmark").addClass('fa-bars');
            main_content.removeClass('loading');
        }

    });

    $(document).on('click','#mobile_menu_action',function(){

        const btn = $(this).find('.fa-solid');
        const wrap = $(".mobile_menu_drawer");
        const body = $("body");

        if(btn.hasClass('fa-bars'))
        {
            wrap.show('slide', {direction: 'left'}, 300);
            btn.removeClass("fa-bars").addClass('fa-xmark');
            body.addClass("no-scroll");
        }
        else
        {
            wrap.hide('slide', {direction: 'left'}, 300);
            btn.removeClass("fa-xmark").addClass('fa-bars');
            body.removeClass("no-scroll");
        }

    });

    $(document).on('click','.mobile_menu_drawer_action_wrapper .fa-xmark',function(){

      $(".mobile_menu_drawer").hide('slide', {direction: 'left'}, 300);
      $('#mobile_menu_action').find('.fa-solid').removeClass("fa-xmark").addClass('fa-bars');
      $("body").removeClass("no-scroll");

    });

    $(window).scroll(function()
    {
        var sticky = $('.sticky');
        const scroll = $(window).scrollTop();

        if (scroll >= 100)
        {
            sticky.addClass('fixed');   
        }
        else
        {
            sticky.removeClass('fixed');   
        }
    });

    $(document).on('click','.add-to-cart-btn',function(){

        const btn = $(this);
        const variants_wrapper = $(".main-product-variants-wrapper");
        const id = $("#product-variant-selector").val();
        const qty = $("#product-qty-selector").val();

        btn.addClass("loading").attr('disabled',true);

        $.ajax({
          type: 'POST',
          url: '/cart/add.js',
          data: {
            id: id,
            quantity: qty
          },
          dataType: 'json',
          success: function(data)
           {
            btn.removeClass("loading").attr('disabled',false);
            $(".main-product-action-wrapper .info_error").remove();
  
            if(!data.id)
            {
              return;
            }
  
            notify("Added to cart","success");
            updateCartCaret();
          },
          error: function(err)
           {
            btn.removeClass("loading").attr('disabled',false);
            notify(err.responseJSON.message,"error");
          }
        });


    });

     $(document).on('click','.cart_item_qty_btn.item_qty_plus',function(){
  
        const wrapper = $(this).parents('.cart_items_box_two_col');
        const id = wrapper.attr('data-id');
        let qty = wrapper.find('.product_qty_input').text();
        qty = parseInt(qty);
  
        if(qty >= 0)
        {
          const new_qty = qty + 1;
  
          wrapper.find(".product_qty_input").val(new_qty);
          updateCartItemQty(id,new_qty);
        }
  
      });

      $(document).on('click','.cart_item_qty_btn.item_qty_minus',function(){
  
        const wrapper = $(this).parents('.cart_items_box_two_col');
        const id = wrapper.attr('data-id');
        let qty = wrapper.find('.product_qty_input').text();
        qty = parseInt(qty);
  
        if(qty > 0)
        {
          const new_qty = qty - 1;
  
          wrapper.find(".product_qty_input").val(new_qty);
          updateCartItemQty(id,new_qty);
        }
  
      });

      $(document).on('click','#checkout_btn',function(){
  
        $("#cart").submit();
  
      });

      $(document).on('click','.paginate_btn',function(){

        const btn = $(this);
        const url = btn.attr("data-next-url");

        if(!url)
        {
          return;
        }

        btn.addClass("loading").attr('disabled',true);

        $.ajax({
          type: 'GET',
          url: url,
          success: function(data) {
            
            let new_products = "";
            
            if($(data).find(".product-grid-container").length > 0)
            {
              new_products = $(data).find(".product-grid-container .product-card-wrapper");
              $(".product-grid-container").append(new_products);
            }
            else if($(data).find(".search_results_grid_inner").length > 0)
            {
              new_products = $(data).find(".search_results_grid_inner .product-card-wrapper");
              $(".search_results_grid_inner").append(new_products);
            }
            
            btn.removeClass("loading").attr('disabled',false);

            const next_url = $(data).find(".paginate_btn").attr("data-next-url");

            if(next_url)
            {
              btn.attr("data-next-url",next_url);
            }
            else
            {
              btn.remove();
            }
          },
          error: function(err) {
            btn.removeClass("loading").attr('disabled',false);
            notify(err.responseJSON.message,"error");
          } 
      });
      
    });

    const swiper = new Swiper('.swiper', {
      loop: true,
      navigation: {
        nextEl: '.swiper-button-next',
        prevEl: '.swiper-button-prev',
      },
      scrollbar: {
        el: '.swiper-scrollbar',
      },
      autoplay: true
    });


    $(document).on('change','#product-variant-selector',function(){

      const selected_option = $(this).find("option:selected");
      const qty = selected_option.attr("data-qty");
      const price = selected_option.attr("data-price");

      $("#product-qty-selector").html("");
      if(parseInt(qty) > 0)
      {
        for(let i=1; i<=qty; i++)
        {
          const option = "<option value='"+i+"'>"+i+"</option>";
          $("#product-qty-selector").append(option);
        }
      }
      else
      {
        const option = "<option value='0'>0</option>";
        $("#product-qty-selector").append(option);
      }
    
      if(parseInt(qty) === 0)
      {
        notify("Selected variant is out of stock","error");
        $(".add-to-cart-btn").attr("disabled", true).addClass("disabled-btn");
      }
      else
      {
        $(".add-to-cart-btn").attr("disabled", false).removeClass("disabled-btn");
      }
      
       $(".product-price").text(price);

    });

    $(document).on('keypress','#header-search-bar',function(e){

      if(e.key === "Enter")
      {
        performSearch($(this).val());
      }

    });

    $(document).on('click','.header-search-bar-wrap .fa-magnifying-glass',function(){

      const input = $(this).siblings('input');
      performSearch(input.val());

    });

    $(document).on('change','.sort_wrapper #SortBy',function(){
  
        const selected_type = $(this).val();
        const url = $("#collection_url").val();
        const wrapper = $(".product-grid-container");
  
        wrapper.addClass("loading");
  
        $.ajax({
          type: 'GET',
          url: url+"?sort_by="+selected_type,
          success: function(data) {
            wrapper.html($(data).find('.product-grid-container').html());
            wrapper.removeClass("loading");
          },
          error: function(){
            wrapper.removeClass("loading");
          }
        });
  
      });

    updateCartCaret();

});
